var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('field-select-module',{attrs:{"board":this.board,"is-print":_vm.isPrint,"types":['field_name', 'department', 'com_name', 'rank', 'writer_name'],"options":[{}, { type: 'date', label: '계획일' }, { type: 'date', label: '작성일', value: 'date', readonly: true }]},model:{value:(_vm.form.stdInfo),callback:function ($$v) {_vm.$set(_vm.form, "stdInfo", $$v)},expression:"form.stdInfo"}}),_c('table-custom',{staticClass:"mt-28px",attrs:{"title":"점검 담당자 그룹","board":_vm.board,"is-print":_vm.isPrint,"tableData":[
      {
        id: 'target',
        title: '점검대상',
        type: 'select',
        selectData: [
          '건설공사 기간 연장',
          '도급전 정보 제공',
          '반기별 점검',
          '보건교육',
          '비상대피 교육',
          '비상대피 자체평가',
          '비상대피 훈련',
          '비상연락/지원 체계도',
          '비상연락망',
          '비상조치계획 수립',
          '사업장 경영방침',
          '산업재해조사',
          '설계변경 요청',
          '수급인 산재예방 평가',
          '순회점검',
          '시정 및 예방조치',
          '아차사고',
          '안전교육',
          '안전보건관리 수행평가',
          '안전보건 예산',
          '안전보건 확보 의무',
          '안전보건대장 작성',
          '안전보건협의체 구성',
          '위험성평가',
          '유해위험요인 파악',
          '작업계획서',
          '작업중지제',
          '작업허가서',
          '장비점검',
          '재발방지계획서',
          '중대재해 발생 조사',
          '기타',
        ],
      },
      { id: 'group', title: '소속명(부서명)/직급', type: 'text' },
      { id: 'type', title: '직책', type: 'select', selectData: ['안전보건총괄책임자', '안전보건책임자', '안전보건조정자', '관리감독자', '안전관리자', '보건관리자', '산업보건의', '현장관리자', '안전담당자', '보건담당자', '담당자'] },
      { id: 'name', title: '성명', type: 'text' },
      { id: 'phone', title: '연락처', type: 'text' },
      { id: 'note', title: '점검방법', type: 'textarea' },
      { id: 'cycle', title: '점검주기', type: 'text' },
    ],"mobile":['target', 'group']},model:{value:(_vm.form.group1),callback:function ($$v) {_vm.$set(_vm.form, "group1", $$v)},expression:"form.group1"}}),_c('table-inspection-group',{staticClass:"mt-28px",attrs:{"title":"점검 담당자 그룹","list":_vm.form.group1,"isPrint":_vm.isPrint,"isReadonly":_vm.board.readonly},on:{"updateList":_vm.updateGroupList}}),_c('file-upload-module',{staticClass:"mt-28px",attrs:{"readonly":_vm.board.readonly,"is-print":_vm.isPrint},model:{value:(_vm.form.fileList),callback:function ($$v) {_vm.$set(_vm.form, "fileList", $$v)},expression:"form.fileList"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }